<div fxLayout='row' fxLayoutAlign="space-around center">
     <div fxLayout='column' style='height:100%' fxLayoutAlign="space-around center">
       <img src='/assets/images/stripe.png'>
       <div></div>
       <img src='/assets/images/logo-black-2.png' style='width:390px'>
       <div *ngIf='connecting' style='text-align:center;margin-top:100px'>Connecting <i class='fa fa-spinner fa-spin'></i></div>
       <div *ngIf='connected' style='text-align:center;margin-top:100px; width:500px'>
          You have successfully connected your Stripe account to Golf GamesKeeper, we can now start collecting payments for you.<br/>
          <button mat-raised-button color='primary' (click)='backToGroupSettings()'>Continue</button>
       </div>
     </div>
</div>